import apiInstance from './apiAuth';

export const tasksApi = {
  getTasksByStages: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiInstance.get(`tasks/by_stages/${query ? `?${query}` : ''}`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getAllTasks: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiInstance.get(`tasks/${query ? `?${query}` : ''}`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  createTask: (taskData) => apiInstance.post('tasks/', taskData, {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  updateTask: (taskId, taskData) => apiInstance.patch(`tasks/${taskId}/`, taskData, {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  updateTaskStatus: (taskId, status) => apiInstance.patch(`tasks/${taskId}/update_status/`, { status }, {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  moveTaskToStage: (taskId, stageId) => apiInstance.patch(`tasks/${taskId}/move_stage/`, { stage_id: stageId }, {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  deleteTask: (taskId) => apiInstance.delete(`tasks/${taskId}/`, {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  getStages: () => apiInstance.get('tasks/stages/', {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  getCompanies: () => apiInstance.get('tasks/companies/', {
    headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
  }),
  getTeamMembers: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiInstance.get(`tasks/team_members/${query ? `?${query}` : ''}`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getAllTeamMembers: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiInstance.get(`team-members/${query ? `?${query}` : ''}`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getTeams: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiInstance.get(`teams/${query ? `?${query}` : ''}`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getClosedDealDetails: (companyId) => {
    return apiInstance.get(`company/${companyId}/closed-deal-details/`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  saveClosedDealDetails: (companyId, data) => {
    return apiInstance.post(`company/${companyId}/closed-deal-details/`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  updateClosedDealDetails: (companyId, data) => {
    return apiInstance.put(`company/${companyId}/closed-deal-details/`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getCallingCards: (companyId) => {
    return apiInstance.get(`company/${companyId}/calling-cards/`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  saveCallingCard: (companyId, data, stageId = 1) => {
    return apiInstance.post(`company/${companyId}/calling-cards/?stage_id=${stageId}`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  updateCallingCard: (companyId, data, stageId = 1) => {
    return apiInstance.put(`company/${companyId}/calling-cards/?stage_id=${stageId}`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  getScoreCards: (companyId) => {
    return apiInstance.get(`company/${companyId}/score-cards/`, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  saveScoreCard: (companyId, data, stageId = 1) => {
    return apiInstance.post(`company/${companyId}/score-cards/?stage_id=${stageId}`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  updateScoreCard: (companyId, data, stageId = 1) => {
    return apiInstance.put(`company/${companyId}/score-cards/?stage_id=${stageId}`, data, {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  },
  checkTeamLeadStatus: () => {
    return apiInstance.get('team-members/check-lead-status/', {
      headers: { Authorization: `Token ${localStorage.getItem('authToken')}` }
    });
  }
};